var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-radio-group',{attrs:{"value":_vm.value},on:{"input":_vm.onInput,"change":_vm.onChange}},[_c('el-radio',{attrs:{"label":"default_sale"}},[_vm._v("使用默认商品")]),_c('el-radio',{attrs:{"label":"assign_sale"}},[_vm._v("使用指定商品")]),_c('el-radio',{attrs:{"label":"clone_sale"}},[_vm._v("使用默认商品克隆")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }